<template>
  <b-container fluid>
    <h3>
      <b-button 
        :to="{ name: 'KpiAfspraken' }" 
        size="lg"
        variant="ghost"
      >
        <font-awesome-icon icon="arrow-left" /> Terug naar overzicht
      </b-button>
    </h3>
    
    <b-card 
      v-if="kpi"
      title="KPI Afspraken"
      no-body
    >
      <b-card-header>
        <b-card-title>KPI Afspraak</b-card-title>
        <b-card-sub-title>orm.type.{{ type }}</b-card-sub-title>
      </b-card-header>

      <kpi-afspraak 
        v-model="kpi" 
        :type="type"
      />
    </b-card>
  </b-container>
</template>

<script>
import { serviceMixin } from '@/mixins/serviceMixin.js'

export default {
    name: 'KpiDetail',
    components: {
      KpiAfspraak: () => import('@/components/KpiAfspraak.vue')
    },
    mixins: [ serviceMixin ],
    props: {
        id: {
            type: Number,
            required: true,
            
        },
       
    },
    data() {
        return  {
          kpi: null,
          type: null
        }
    },
    computed: {
        url: function() {
            return "/units/" + this.unit.Id;
        },
    },
    watch: {},
    mounted () {
        this.getKpiDetail();
    },
    methods: {
      getKpiDetail() {
        console.log(this.id);
        this.get(this.id > 0 ? "/admin/kpi/kpiafspraken/"+ this.id : "/admin/kpi/complexafspraken/nieuw").then(
          (response) => {
            console.log(response);
            this.kpi = response.data['kpi-afspraak'];
            this.type = response.data['type'];
          }
        )
        // get "/admin/kpi/afspraak/{id}"
  
      }
    },
          
}
</script>
